/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditpack_Bestvalue2Inputs */

const zh_creditpack_bestvalue2 = /** @type {(inputs: Creditpack_Bestvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最超值`)
};

const en_creditpack_bestvalue2 = /** @type {(inputs: Creditpack_Bestvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best Value`)
};

const es_creditpack_bestvalue2 = /** @type {(inputs: Creditpack_Bestvalue2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejor Valor`)
};

/**
* | output |
* | --- |
* | "Best Value" |
*
* @param {Creditpack_Bestvalue2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const creditpack_bestvalue2 = /** @type {((inputs?: Creditpack_Bestvalue2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditpack_Bestvalue2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_creditpack_bestvalue2(inputs)
	if (locale === "en") return en_creditpack_bestvalue2(inputs)
	return es_creditpack_bestvalue2(inputs)
});
export { creditpack_bestvalue2 as "creditPack_bestValue" }